<div class="modal-container">
  <!-- Header -->
  <div class="modal-header" [class.header-invalidated]="isInvalidated()">
    <div class="header-left">
      <h2 style="color:aliceblue">Détails du Sinistre</h2>
      <span class="claim-number">{{ data.claimNumber }}</span>
      <span class="status-badge" [ngClass]="getStatusClass(data.status)">
        {{ getStatusLabel(data.status) }}
      </span>
      <div class="header-actions" *ngIf="!data?.fromHistory">
        <div class="action-dropdown-wrapper" [class.open]="showActions">
          <button class="btn-action btn-action-primary" (click)="toggleActions()" title="Actions">
            <span uk-icon="icon: menu"></span> Action
          </button>

          <div class="action-dropdown" *ngIf="showActions">
            <!-- Only Transférer action for this modal -->
            <button class="action-item" (click)="onTransferAction()">
              <span uk-icon="icon: refresh"></span> Transférer
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="header-right">
      <button class="btn-close" (click)="close()" title="Fermer">
        <span uk-icon="icon: close"></span>
      </button>
    </div>
  </div>

  <!-- Section: Info Police / Éléments d'évaluation
  <div class="detail-section" *ngIf="data?.evaluationItems?.length > 0">
    <div class="section-header">
      <span uk-icon="icon: briefcase"></span>
      Info Police - Éléments d'évaluation
    </div>
    <div class="section-content">
      <table class="uk-table uk-table-small" style="width:100%;">
        <thead>
          <tr>
            <th>Code Garantie</th>
            <th>Type</th>
            <th>Montant Évalué</th>
            <th>Statut Item</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let it of data.evaluationItems">
            <td>{{ it.coverageCode || it.CoverageCode || '-' }}</td>
            <td>{{ it.itemType || it.ItemType || '-' }}</td>
            <td>{{ (it.evaluationAmount || it.EvaluationAmount) | number:'1.0-0' }} FCFA</td>
            <td>{{ it.itemStatus || it.ItemStatus || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div> -->

  <!-- Alerte pour sinistre invalidé -->
  <div class="invalidation-alert" *ngIf="isInvalidated()">
    <div class="alert-icon">
      <span uk-icon="icon: warning; ratio: 1.5"></span>
    </div>
    <div class="alert-content">
      <strong>Ce sinistre a été invalidé</strong>
      <p class="justification-text" *ngIf="data.claimDetail?.justificationInvalidation" style="color: red;">
        <span class="justification-label">Motif d'invalidation :</span>
        {{ data.claimDetail.justificationInvalidation }}
      </p>
      <p class="no-justification" *ngIf="!data.claimDetail?.justificationInvalidation">
        Aucun motif d'invalidation renseigné.
      </p>
    </div>
  </div>

  <!-- Content -->
  <div class="modal-content">
    <!-- Section: Informations Générales -->
    <div class="detail-section">
      <div class="section-header">
        <span uk-icon="icon: info"></span>
        Informations Générales
      </div>
      <div class="section-content">
        <div class="detail-grid">
          <div class="detail-item">
            <span class="label">N° Sinistre</span>
            <span class="value">{{ data.claimNumber }}</span>
          </div>
          <div class="detail-item">
            <span class="label">N° Contrat Manuel</span>
            <span class="value">{{ data.contratManualNumber }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Produit</span>
            <span class="value">{{ data.productName || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">ID Police</span>
            <span class="value policy-id" [title]="data.policyID">
              {{  data.policyIDHelios || data.policy?.id || data.policyNumber || 'N/A' }}
            </span>
          </div>
          <div class="detail-item">
            <span class="label">ID Banque</span>
            <span class="value">{{ data.bankId }}</span>
          </div>
          <div class="detail-item">
            <span class="label">ID Agence</span>
            <span class="value">{{ data.idagence }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Créé le</span>
            <span class="value">{{ data.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
          </div>
        </div>
      </div>
      
    </div>

    <!-- Section: Détails du Sinistre -->
    <div class="detail-section">
      <div class="section-header">
        <span uk-icon="icon: file-text"></span>
        Détails du Sinistre
      </div>
      <div class="section-content">
        <div class="detail-grid">
          <div class="detail-item">
            <span class="label">Date de Survenance</span>
            <span class="value">{{ (data.claimDetail?.incidenceDate || data.incidenceDate || data.dateMinimum) |
              date:'dd/MM/yyyy' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Date de Déclaration</span>
            <span class="value highlight">{{ (data.claimDetail?.notificationDate || data.notificationDate) |
              date:'dd/MM/yyyy' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Montant Estimé</span>
            <span class="value amount">{{ data.claimDetail?.initialEstimatingAmount | number:'1.0-0' }} FCFA</span>
          </div>
          <div class="detail-item">
            <span class="label">Sinistre Corporel</span>
            <span class="value" [ngClass]="{'corporel-yes': data.claimDetail?.isCorporal}">
              {{ data.claimDetail?.isCorporal ? 'Oui' : 'Non' }}
            </span>
          </div>
          <div class="detail-item">
            <span class="label">Élément de Risque</span>
            <span class="value">{{ data.claimDetail?.rickElement || data.claimDetail?.riskElement || data.riskElement ||
              data.riskElementDetail || data.claimDetail?.rickElementID || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Sous-Élément de Risque</span>
            <span class="value">{{ data.claimDetail?.subRick8ElementID }}</span>
          </div>
        </div>

        <!-- Circonstances -->
        <div class="detail-text-block">
          <span class="label">Circonstances</span>
          <p class="text-content">{{ data.claimDetail?.circumstance || 'Non renseigné' }}</p>
        </div>

        <!-- Conséquences -->
        <div class="detail-text-block">
          <span class="label">Conséquences</span>
          <p class="text-content">{{ data.claimDetail?.consequence || 'Non renseigné' }}</p>
        </div>

        <!-- Garantie code -->
        <div class="detail-text-block">
          <span class="label">Garantie code</span>
          <p class="text-content">{{ data.claimDetail?.warrantyCode || 'Non renseigné' }}</p>
        </div>

        <!-- Conséquences Corporelles (si applicable) -->
        <div class="detail-text-block" *ngIf="data.claimDetail?.isCorporal && data.claimDetail?.corporalconsequence">
          <span class="label corporel-label">Conséquences Corporelles</span>
          <p class="text-content">{{ data.claimDetail?.corporalconsequence }}</p>
        </div>

        <!-- Justification d'invalidation dans les détails (en rouge) -->
        <div class="detail-text-block invalidation-block"
          *ngIf="isInvalidated() && data.claimDetail?.justificationInvalidation">
          <span class="label invalidation-label">
            <span uk-icon="icon: warning; ratio: 0.8"></span>
            Motif d'Invalidation
          </span>
          <p class="text-content invalidation-text">{{ data.claimDetail.justificationInvalidation }}</p>
        </div>
      </div>
    </div>

    <!-- Section: Documents (simple list) -->
    <div class="detail-section" *ngIf="getValidDocumentsCount() > 0">
      <div class="section-header">
        <span uk-icon="icon: folder"></span>
        Documents Chargés ({{ getValidDocumentsCount() }})
      </div>
      <div class="section-content">
        <div class="documents-list">
          <div class="document-item" *ngFor="let doc of uploadedDocuments">
            <div class="doc-icon">
              <span [attr.uk-icon]="'icon: ' + getFileIcon(doc.filePath) + '; ratio: 1.2'"></span>
            </div>
            <div class="doc-info">
              <a class="doc-label" (click)="previewDocument(doc)" style="cursor:pointer">{{ doc.label }}</a>
              <span class="doc-filename">{{ getFileName(doc.filePath) }}</span>
            </div>
            <div class="doc-actions">
              <button class="uk-button uk-button-small" (click)="previewDocument(doc)">Télécharger</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section: Pièces demandées (sans fichier) -->
    <div class="detail-section" *ngIf="requestedDocuments?.length > 0">
      <div class="section-header">
        <span uk-icon="icon: list"></span>
        Pièces demandées ({{ requestedDocuments.length }})
      </div>
      <div class="section-content">
        <ul class="requested-list">
          <li *ngFor="let r of requestedDocuments">
            <span class="requested-label">{{ r.label }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- <div class="modal-footer">
    <button class="uk-button uk-button-default" (click)="close()">Fermer</button>
    <button class="uk-button uk-button-primary" (click)="transfer()">Transférer</button>
  </div> -->
</div>
